import { useLocation } from '@gatsbyjs/reach-router';
import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import TerraModalContent from '@components/Modal/Content/TerraModalContent';

import { TERRA_CONSENT } from '@constants/consents';

import { useGetConsents } from '@hooks/api/consent';
import { useGetUser } from '@hooks/api/user';

function TerraOverlay() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const { data: userData, loading: userLoading } = useGetUser();
  const { data: consentData, loading: consentLoading } = useGetConsents();

  const loading = userLoading || consentLoading;

  const validicId = userData?.getUserRecord.vitall_patient?.validic_id;

  const terraConsent = consentData.find((d) => d.hasCategory(TERRA_CONSENT));
  const hasConsented = terraConsent?.isActive();

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Existing Validic user and has not consented to Terra
    if (
      validicId &&
      !hasConsented &&
      !loading &&
      !location.pathname.includes('devices')
    ) {
      handleOpenModal();
    }
    return () => handleCloseModal();
  }, [hasConsented, loading, location.pathname, validicId]);

  return (
    <Dialog open={open}>
      <TerraModalContent onClose={handleCloseModal} />
    </Dialog>
  );
}

export default withErrorBoundary(TerraOverlay, {
  fallback: null,
});
